/*
 *  based on code of leanModal
 */
(function($) {
    'use strict';
    $.fn.extend({
        sModal : function(options) {
            var defaults = {
                top: 100,
                overlay: 0.4,
                closeButton: null,
                autoClose: false,
                className: 'modalOverlay'
            };
            var viewPortHeight;
            var modal_width;
            var modal_height;
            var overlay = $('<div class="modalOverlay"></div>');

            var isMobile = {
                iOS: function() {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                }
            };
            var iOSMargin = 75;

            function close_modal(modal_id) {
                var overflowedSuffix = modal_id === "#lightbox_ws" ? "_ws" : "";
                $('body').removeClass('overflowed' + overflowedSuffix);
                overlay.stop().fadeOut(200);
                $(modal_id).hide();
                if (options.onClose) {
                    options.onClose();
                }
            }

            function initModal(modal_id) {
                viewPortHeight = isMobile.iOS()?viewportSize.getHeight()-iOSMargin:viewportSize.getHeight();
                $(modal_id).css({
                    'max-height'  : viewPortHeight
                });

                modal_width = $(modal_id).outerWidth();
                modal_height = $(modal_id).outerHeight();
            }

            $('body').append(overlay);
            options = $.extend(defaults, options);
            return this.each(function() {
                var o = options;
                $(this).unbind('click').click(function(e) {
                    var modal_id = $(this).attr("href");
                    var overflowedSuffix = modal_id === "#lightbox_ws" ? "_ws" : "";

	                $('body').addClass('overflowed' + overflowedSuffix);
                    overlay.addClass(modal_id.substring(1) + '_overlay');
                    if (o.autoClose) {
                        overlay.on('click', function() {
                            close_modal(modal_id);
                        });
                    }

                    if (o.closeButton) {
                        $(o.closeButton).on('click', function() {
                            close_modal(modal_id);
                        });
                    }

                    initModal(modal_id);
                    $(modal_id).css({
                        'display'     : 'block',
                        'position'    : 'fixed',
                        'z-index'     : 11000,
                        'left'        : 50 + '%',
                        'margin-left' : -(modal_width / 2) + 'px',
                        'top'         : 50 + '%',
                        'margin-top'  : -(modal_height / 2) + 'px'
                    });

                    overlay.css({opacity : 0}).show().stop().fadeTo(200, o.overlay);
                    e.preventDefault();

                    $(window).on('resize', function() {
                        initModal(modal_id);
                        $(modal_id).css({
                            'margin-left' : -(modal_width / 2) + 'px',
                            'margin-top'  : -(modal_height / 2) + 'px'
                        });
                    });
                });
            });
        }
    });
}(jQuery));